// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { COUNTRIES } from '../../../const';
import { AREA_MAP } from '../../../path/areaPath';
import type { History } from '../../../types/commonTypes';

type Props = {
  children: any,
  id: string,
  history: History
}

type State = {
  className: string,
}

class Country extends React.Component<Props, State> {
  state = {
    className: '',
  };

  mouseOver = () => {
    this.setState({ className: 'is-active' });
  };

  mouseLeave = () => {
    this.setState({ className: '' });
  };

  render() {
    const country = COUNTRIES[this.props.id] || {};
    return (
      <a
        onMouseEnter={this.mouseOver}
        onMouseLeave={this.mouseLeave}
        id={this.props.id}
        onClick={() => this.props.history.push(`${AREA_MAP}?area=${country.id}`)}
        className={this.state.className}
      >
        {this.props.children}
      </a>
    );
  }
}

export default withRouter(Country);
